module.exports = {"513433001":"高阳街道","513433101":"漫水湾镇","513433102":"大桥镇","513433103":"复兴镇","513433104":"泸沽镇","513433106":"彝海镇","513433107":"石龙镇","513433109":"河边镇","513433110":"锦屏镇","513433112":"里庄镇","513433113":"惠安镇","513433114":"宏模镇","513433115":"泽远镇","513433116":"若水镇","513433117":"棉沙镇","513433118":"磨房沟镇","513433226":"和爱藏族乡","513433230":"新兴乡","513433231":"健美乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513433.json
// module id = 2574
// module chunks = 0